<div class="image-box">
  <img class="image-box__image" [src]="imgSrc" alt="" />
  <div style="position: absolute; top: 16px; right: 16px">
    <flow-button [icon]="iconService.Icon.cross" (click)="close()"></flow-button>
  </div>
</div>
